import {
  Action_GetCauHinhJS,
  Action_GetCauHinhJSSuccess,
  Action_SaveLichSuView,
  Action_SaveLichSuViewSuccess,
  Action_GetLichSuView,
  Action_GetLichSuViewSuccess
} from "actions/HeThongNT/actionTypes";

const initialState = {
  objData: {},
  lstMenuThuongDung: {}
};

const Reducer_GetCauHinhJS = (state, action) => ({
  ...state,
  objData: action.payload,
});
const Reducer_GetCauHinhJSSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objData: action.payload,
  };
};
////////////////////////////////////
const Reducer_SaveLichSuView = (state, action) => ({
  ...state,
  objData: action.payload,
});
const Reducer_SaveLichSuViewSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
  };
};
////////////////////////////////////
const Reducer_GetLichSuView = (state, action) => ({
  ...state,
  objData: action.payload,
});
const Reducer_GetLichSuViewSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    lstMenuThuongDung: action.payload,
  };
};
////////////////////////////////////
// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_GetCauHinhJS:
      return Reducer_GetCauHinhJS(state, action);
    case Action_GetCauHinhJSSuccess:
      return Reducer_GetCauHinhJSSuccess(state, action);

    case Action_SaveLichSuView:
      return Reducer_SaveLichSuView(state, action);
    case Action_SaveLichSuViewSuccess:
      return Reducer_SaveLichSuViewSuccess(state, action);

    case Action_GetLichSuView:
      return Reducer_GetLichSuView(state, action);
    case Action_GetLichSuViewSuccess:
      return Reducer_GetLichSuViewSuccess(state, action);

    default:
      return state;
  }
};
export default authReducer;
